import React from 'react'

/**
 * Common HTML wrapper for email templates
 * Provides the HTML skeleton: html > head > body > table
 */
export const EmailWrapper = ({ children }) => (
    <html>
        <head>
            <meta charSet='UTF-8' />
        </head>
        <body>
            <table cellSpacing='10'>
                <tbody>{children}</tbody>
            </table>
        </body>
    </html>
)
